import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=de68459c"
import script from "./DataTableFooter.vue?vue&type=script&lang=js"
export * from "./DataTableFooter.vue?vue&type=script&lang=js"
import style0 from "./DataTableFooter.vue?vue&type=style&index=0&id=de68459c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DataTableFooter.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports